'use client';

import Btn, { BtnProps } from '@/components/ui/Btn';
import Txt, { TxtProps } from '@/components/ui/Txt';

type QuickNavProps = BtnProps<
  'a',
  {
    TxtProps?: TxtProps;
  }
>;

const QuickNavButton = ({ TxtProps, children, ...props }: QuickNavProps) => {
  return (
    <Btn
      {...props}
      variant="text"
      underline="none"
      endIcon="arrowDown"
      wrap
      EndIconProps={{ cx: { fontSize: 'body', color: 'accent' } }}>
      <Txt variant="body" as="span" headingFont {...TxtProps}>
        {children}
      </Txt>
    </Btn>
  );
};

export default QuickNavButton;
